/**
 * True on the unauthenticated bearer-link pages (`/guest/{token}`, the
 * public QR report `/report/{token}`, the set-password page
 * `/reset-password?oobCode=…`): the token in the URL is the credential, so
 * nothing may report the URL to a third party. Analytics' automatic
 * page_view would send it to Google as `page_location`; these pages are
 * opened directly, never navigated to from the app, so not initialising
 * Analytics on them is enough (src/firebase.ts).
 */
export const isTokenPath = (pathname: string): boolean =>
    /^\/(guest|report)\//.test(pathname) || pathname === '/reset-password';
